module.exports = __webpack_public_path__ + "static/img/three.e290c0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/strawberryImg/three.png
// module id = VdnB
// module chunks = 1